import {IItemForUI} from '@/stores/ItemsStore/ItemsStore.types';

import {HttpError} from '@specials/project-user';

import {FrontendError} from '@/services/ErrorService/FrontendError';
import {StatefulStore} from '@/stores/StatefulStore';

export type ItemModalContentState = {
  currentItem: IItemForUI | null;
};

export class ItemModalContentStore extends StatefulStore<ItemModalContentState, HttpError | FrontendError> {
  public setCurrentItem = (currentItem: IItemForUI): void => {
    this.toSuccess({
      currentItem,
    });
  };

  public getCurrentItem(): IItemForUI | null {
    try {
      return this.getDataOrFail().currentItem;
    } catch (e) {
      return null;
    }
  }

  public updateCurrentItem = (partialItem: Partial<IItemForUI>): void => {
    const currentItem = this.getCurrentItem();
    const state = this.getDataOrFail();

    const newCurrentItem = currentItem
      ? {
          ...currentItem,
          ...partialItem,
        }
      : currentItem;

    this.toSuccess({
      ...state,
      currentItem: newCurrentItem,
    });
  };
}
